import { AvailableCountryCodes } from "./CountryCode";
import { Geometry } from "./Geometry";
import { PaperFormat } from "./PaperFormat";

export enum LetterStatus {
  CreateAndSendQueued = "CREATE_AND_SEND_QUEUED",
  CreateQueued = "CREATE_QUEUED",
  Created = "CREATED",
  CancellationRequested = "CANCELLATION_REQUESTED",
  CancellationFailed = "CANCELLATION_FAILED",
  CreateFailed = "CREATE_FAILED",
  SendFailed = "SEND_FAILED",
  Ready = "READY",
  Printing = "PRINTING",
  ProcessedForDelivery = "PROCESSED_FOR_DELIVERY",
  Completed = "COMPLETED",
  Cancelled = "CANCELLED",
  WaitingToBeSent = "WAITING_TO_BE_SENT",
  Sent = "SENT",
}

export type Letter = {
  id: string;
  batch_id: string;
  created_at: string;
  updated_at: string;
  status: LetterStatus;
  sender_address_line_1: string;
  sender_name: string;
  sender_post_code: string;
  sender_city: string;
  sender_province: string;
  recipient_address_line_1: string;
  recipient_name: string;
  recipient_post_code: string;
  recipient_city: string;
  recipient_province: string;
  signed_pdf_url?: string;
};

export enum SiteLetterStatus {
  PENDING = "PENDING",
  FAILED = "FAILED",
  CREATED = "CREATED",
  WAITING_TO_BE_SENT = "WAITING_TO_BE_SENT",
  CANCELLED = "CANCELLED",
  SENT = "SENT",
}

export type CurrentSiteLetterStatus = {
  status: SiteLetterStatus;
  created_at: string;
};

export type SiteLetter = {
  id: string;
  letter_id: string;
  name: string;
  team_id: string;
  created_at: string;
  created_by: string;
  title_geometry: Geometry;
  letter: Letter;
  current_status: CurrentSiteLetterStatus;
};

export type SiteLetterInput = {
  name: string;
  title_geometry: Geometry;
  html: string;
  sender_address_line_1: string;
  sender_name: string;
  sender_post_code: string;
  sender_city: string;
  sender_province: string;
  sender_country_code: AvailableCountryCodes;
  recipient_address_line_1: string;
  recipient_name: string;
  recipient_post_code: string;
  recipient_city: string;
  recipient_province: string;
  recipient_country_code: AvailableCountryCodes;
  logo_s3_object_key?: string;
  signature_s3_object_key?: string;
  variables: {
    [key: string]: string;
  };
  paper_format: PaperFormat;
};
